import React from 'react';

export default React.memo(function PrepValidation({ session, nbAmb, nbFroid, photos, nbCartons, nbCartonsVrac, syncing, onMarkPrete, onResetEnCours, showToast }) {
  return (
    <div style={{ marginTop: 16, paddingBottom: 10 }}>
      <div className="sep"></div>

      {/* Pharmacie déjà partie */}
      {session.status === 'depart_valide' && (
        <div style={{
          padding: '12px', borderRadius: 10, background: '#D6EAF8', border: '2px solid #85B7EB', textAlign: 'center',
        }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#1A5276' }}>🚚 Partie en livraison</div>
          <div style={{ fontSize: 11, color: '#1A5276', marginTop: 2 }}>Annulation possible dans l'onglet Départs</div>
        </div>
      )}

      {/* Pharmacie prête → en attente de validation départ */}
      {session.status === 'prete' && (
        <div>
          <div style={{
            padding: '12px', borderRadius: 10, marginBottom: 8,
            background: '#D5F5E3', border: '2px solid #82E0AA', textAlign: 'center',
          }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#1E6B3C' }}>✅ Prête à partir</div>
            <div style={{ fontSize: 11, color: '#1E6B3C', marginTop: 2 }}>En attente de validation dans Départs</div>
          </div>
          <button onClick={onResetEnCours} style={{
            width: '100%', padding: 12, borderRadius: 10, border: '1.5px solid #E2E2E8',
            background: 'white', color: '#888', fontSize: 13, fontWeight: 600,
            cursor: 'pointer', fontFamily: 'inherit',
          }}>↩️ Remettre en préparation</button>
        </div>
      )}

      {/* Pharmacie en cours → bouton Prête à partir */}
      {session.status === 'en_cours' && (() => {
        const totalColis = (nbAmb || 0) + (nbFroid || 0) + (nbCartons || 0);
        const hasPhotos = photos && photos.length > 0;
        const canMark = totalColis > 0 && hasPhotos;
        const missing = [];
        if (totalColis === 0) missing.push('caisses ou cartons');
        if (!hasPhotos) missing.push('photos (produits + étiquette)');
        return (
          <div>
            {/* Checklist visuelle */}
            <div style={{ marginBottom: 8, padding: '10px 12px', borderRadius: 10, background: '#F8FAFC', border: '1px solid ' + (canMark ? '#82E0AA' : '#E5E7EB') }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#6B7280', marginBottom: 6 }}>Checklist avant départ :</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                <span style={{ fontSize: 14 }}>{totalColis > 0 ? '✅' : '⬜'}</span>
                <span style={{ fontSize: 12, color: totalColis > 0 ? '#166534' : '#9CA3AF', fontWeight: totalColis > 0 ? 600 : 400 }}>
                  Caisses/cartons ({totalColis})
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ fontSize: 14 }}>{hasPhotos ? '✅' : '⬜'}</span>
                <span style={{ fontSize: 12, color: hasPhotos ? '#166534' : '#9CA3AF', fontWeight: hasPhotos ? 600 : 400 }}>
                  Photos produits + étiquette pharmacie ({photos?.length || 0})
                </span>
              </div>
            </div>

            <button onClick={() => {
              if (!canMark) {
                showToast('⛔ Il manque : ' + missing.join(' + '), 'error');
                return;
              }
              onMarkPrete();
            }} disabled={syncing || !canMark} style={{
              width: '100%', padding: 16, borderRadius: 12, border: 'none',
              background: canMark ? (syncing ? '#888' : '#166534') : '#E5E7EB',
              color: canMark ? 'white' : '#9CA3AF',
              fontSize: 15, fontWeight: 700,
              cursor: canMark ? (syncing ? 'wait' : 'pointer') : 'not-allowed',
              fontFamily: 'inherit',
            }}>{syncing ? '⏳ Envoi…' : '✅ Prête à partir'}</button>
          </div>
        );
      })()}
    </div>
  );
});
